import {
  getDefaultQuickResponses,
  getStaticFirstMessage,
  type SupportedLanguage,
} from '@krishanmadan/core/src/model/const';
import { sfyr } from '@krishanmadan/core/src/_ctx/sfyr';
import { _set } from '@epihub/core/src/fn/object';
import { useGlobalStore } from '../store/useGlobalStore';

export function updateLanguage(language: SupportedLanguage) {
  if (useGlobalStore.getState().settings.language === language) {
    return;
  }

  // Update the global store
  useGlobalStore.getState().settings.updateLanguage(language);

  // Update sfyr context
  sfyr.context.update((prev) => ({ ...prev, lang: language }));

  // Update quick responses (if the ones which are set are the default ones)
  useGlobalStore.getState().settings.setQuickResponses(getDefaultQuickResponses(language));

  // Update first message
  useGlobalStore.getState().conversation.updateConversation((conv) => {
    const messages = [...conv.messages];
    _set(messages, '[0]', getStaticFirstMessage(language));
    return {
      ...conv,
      messages,
    };
  });
}
